const wishlistIcon = document.querySelector(".wishlist-icon");

const setDefaultButtonText = () => {
    document.querySelectorAll('.wishlist-cart, .wishlist-move-cart').forEach(button => {
        button.classList.add("wishlist-btn");
        button.textContent = "Add to cart";
    });
};

const svgChange = () => {
    document.querySelectorAll('.wishlist-remove, .wishlist_page_remove_product').forEach(button => {
        button.innerHTML = wishlistIcon.innerHTML;
    });
};

export const buttonMutationObserver = () => {
    const wishlistRow = document.querySelector(".wishlist-row");
    if (wishlistRow) {
        let isCompleted = false;
        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if(mutation.target.nodeName === 'BUTTON') return;
                if (mutation.type === 'childList') {
                    svgChange();
                    setDefaultButtonText();
                    isCompleted = true;
                }
            }
            isCompleted && observer.disconnect();
        });
        observer.observe(wishlistRow, {
            childList: true,
            subtree: true
        });
    }
}